import script from "./WithdrawInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawInfo.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawInfo.vue?vue&type=style&index=0&id=2c504478&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c504478"]])

export default __exports__